function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m33.9441 4.0921v19.3674c0 2.731 2.2432 4.9742 4.9742 4.9742h7.2075c2.7666 0 5.2807 1.1307 7.102 2.952 1.8214 1.8215 2.9521 4.3357 2.9521 7.1021v7.726h-30.4014c-.4528-.9079-.7681-1.944-1.9835-1.944-1.2157 0-1.5305 1.036-1.9834 1.944h-13.8917v-42.1217zm-22.32 6.9963h18.6158v-3.2921h-18.6158zm18.6158 3.7042h-18.6158v27.717h8.0554c1.012-1.2216 2.5248-1.944 4.1155-1.944 1.5934 0 3.101.7212 4.1148 1.944h24.5659v-4.0218c0-1.7439-.715-3.3312-1.8669-4.4831-1.1518-1.1518-2.7389-1.8668-4.483-1.8668h-7.2075c-4.7758 0-8.6784-3.9026-8.6784-8.6784z",
  fill: "#015168",
  fillRule: "nonzero"
});

var SvgReittiAlle3Km = function SvgReittiAlle3Km(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: "46.5666mm",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 63.5 46.5666",
    width: "63.5mm",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReittiAlle3Km, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reitti-alle-3km.c58fa8b5.svg";
export { ForwardRef as ReactComponent };